import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'boolDisplay', standalone: true })
export class BoolDisplayPipe implements PipeTransform {
  transform(value: boolean | null | undefined): string {
    if (value === null || value === undefined) return 'Not set';
    return value ? 'Yes' : 'No';
  }
}
